import { render, staticRenderFns } from "./TextReplacementHint.vue?vue&type=template&id=1bab9737&scoped=true&"
import script from "./TextReplacementHint.vue?vue&type=script&lang=js&"
export * from "./TextReplacementHint.vue?vue&type=script&lang=js&"
import style0 from "./TextReplacementHint.vue?vue&type=style&index=0&id=1bab9737&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab9737",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCol,VDataTable,VIcon,VListItem,VListItemContent,VListItemTitle,VRow,VSlideXTransition})
